import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/Shared";
import { AuthShell } from "@/components/AuthShell";
import { publicApi, formBody, errMsg } from "@/lib/api";

const BackToLogin = () => (
  <p className="mt-8 text-center">
    <Link to="/login" className="inline-flex items-center gap-2 font-bold text-emerald-700 hover:text-emerald-900" data-testid="back-to-login-link">
      <ArrowLeft className="w-4 h-4" /> Back to log in
    </Link>
  </p>
);

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await publicApi.post("/auth/forgot-password", formBody({ email }));
      setSent(data.message);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  if (sent)
    return (
      <AuthShell title="Check your email">
        <div className="mt-8 rounded-2xl border border-emerald-200 bg-emerald-50 p-5 flex items-start gap-3" data-testid="forgot-password-success">
          <MailCheck className="w-6 h-6 text-emerald-700 shrink-0" />
          <div className="text-emerald-900">
            <p className="font-semibold">{sent}</p>
            <p className="text-sm mt-2 text-emerald-800">The link expires in 60 minutes. Check your spam folder if you don't see it.</p>
          </div>
        </div>
        <BackToLogin />
      </AuthShell>
    );

  return (
    <AuthShell title="Forgot your password?" subtitle="Enter the email you use for MileageTax and we'll send you a link to set a new password.">
      <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-password-form">
        <Field label="Email" htmlFor="fp-email">
          <Input id="fp-email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 text-base" data-testid="forgot-password-email-input" />
        </Field>
        {error && (
          <p className="text-sm font-medium text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2.5" data-testid="forgot-password-error">
            {error}
          </p>
        )}
        <button type="submit" disabled={loading} className="mt-btn-primary w-full" data-testid="forgot-password-submit-button">
          {loading && <Loader2 className="w-5 h-5 animate-spin" />}
          Send Reset Link
        </button>
      </form>
      <BackToLogin />
    </AuthShell>
  );
}
